/* global Cookies, attachEvent */

// *******************************************************************************
// 1.0 - Cookie banner
// *******************************************************************************

const cookieElement = document.querySelector('.cookie-banner');
const cookieModalEle = document.querySelector('.cookie-banner-modal');
const allowedCookies = [];

const loadScripts = () => {
  const scripts = document.querySelectorAll('.sp-cookies.gtm');
  scripts.forEach((script) => {
    // eslint-disable-next-line no-param-reassign
    script.type = 'text/javascript';
    document.head.appendChild(script);
  });
};

const toggleCookieClass = (toggle) => {
  loadScripts();
  cookieElement.classList.toggle('cookie-not-set', toggle);
};

if (cookieElement) {
  if (!Cookies.get('cookie_banner_seen')) {
    cookieElement.classList.add('cookie-not-set');
  }

  attachEvent('.btn--cookie-accept', 'click', (ev) => {
    const checkboxes = document.querySelectorAll('.cookie-banner-modal__content .mod-toggle__input');
    checkboxes.forEach((checkbox) => {
      allowedCookies.push(checkbox.id);
    });
    allowedCookies.push('cookie-set');
    Cookies.set('cookie_banner_seen', allowedCookies, { expires: 365 });
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  });

  attachEvent('.btn--cookie-decline', 'click', (ev) => {
    Cookies.remove('cookie_banner_seen', 'cookie-set', { expires: 365 });
    toggleCookieClass(false);
    ev.preventDefault();
  });
}

if (!cookieElement) {
  loadScripts();
}

// *******************************************************************************
// 2.0 - Cookie banner Modal Open
// *******************************************************************************

const cookieSettingsButtons = document.querySelectorAll('.cookie-banner__settings-link');
cookieSettingsButtons.forEach((cookieSettingsButton) => {
  cookieSettingsButton.addEventListener('click', (ev) => {
    if (cookieModalEle) {
      cookieModalEle.classList.add('is-open-modal');
      ev.preventDefault();
    }
  });
});

// *******************************************************************************
// 3.0 - Cookie banner Modal Close
// *******************************************************************************

attachEvent('.cookie-banner-modal__close', 'click', (ev) => {
  if (cookieModalEle) {
    cookieModalEle.classList.remove('is-open-modal');
    ev.preventDefault();
  }
});

// *******************************************************************************
// 4.0 - Close Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const cookieModal = document.querySelector('.cookie-banner-modal');
    if (cookieModal) {
      cookieModal.classList.remove('is-open-modal');
    }
  }
});

// *******************************************************************************
// 5.0 - Close Modal When Click Out
// *******************************************************************************

document.addEventListener('click', (evt) => {
  const modalInner = document.querySelector('.cookie-banner-modal__inner');
  const toggleBtnEles = document.querySelectorAll('.cookie-banner__settings-link');
  let targetElement = evt.target; // clicked element
  let include = false;
  do {
    // eslint-disable-next-line no-loop-func
    toggleBtnEles.forEach((toggleBtnElem) => {
      if (toggleBtnElem === targetElement) {
        include = true;
      }
    });
    if (targetElement === modalInner || include) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  if (cookieModalEle) {
    cookieModalEle.classList.remove('is-open-modal');
  }
});

attachEvent('.cookie-banner-modal__footer .btn--allow', 'click', (ev) => {
  const checkboxes = document.querySelectorAll('.cookie-banner-modal__content .mod-toggle__input');
  checkboxes.forEach((checkbox) => {
    allowedCookies.push(checkbox.id);
  });
  allowedCookies.push('cookie-set');
  Cookies.set('cookie_banner_seen', allowedCookies, { expires: 365 });
  // eslint-disable-next-line no-restricted-globals
  location.reload();
});

attachEvent('.cookie-banner-modal__footer .btn--confirm-choice', 'click', (ev) => {
  const checkboxes = document.querySelectorAll('.cookie-banner-modal__content .mod-toggle__input');
  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      allowedCookies.push(checkbox.id);
    }
  });
  allowedCookies.push('cookie-set');
  Cookies.set('cookie_banner_seen', allowedCookies, { expires: 365 });
  // eslint-disable-next-line no-restricted-globals
  location.reload();
});
